import store from '../store/store'
import axios from '../axios'

export default class UserService {

  getLazyUsers(filterId, page, rows, sortField, sortOrder, searchText, filterbody) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/usersfilterbypage/' + filterId + '/' + page + '/' +  rows + '/' +  sortField + '/' +  sortOrder + '/' + searchText
        var response = await axios.post(path, filterbody)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getHelpVideos() {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/helpVideos'

        var response = await axios.get(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updateUserWidget(id, obj) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/updateUserWidget/' + id
        
        var response = await axios.put(path, obj)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updateUserEmail(id, obj) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/updateUserEmail/' + id
        
        var response = await axios.put(path, obj)
        
        // 
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  saveUserWidget(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/saveUserWidget'
        
        var response = await axios.post(path, obj)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getDashboardWidgets() {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/dashboardWidgets'

        var response = await axios.get(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getCustomUserWidgetData(path) {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await axios.get(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getUserWidgetsByUserId(userId) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/getUserWidgets/' + userId
        
        var response = await axios.get(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getUserWidgetsByHard(userId) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/getUserWidgets/' + userId
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/userWidgets`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getUserWidgets(userId) {
    return new Promise(async (resolve, reject) => {
      if (store.getters[`commons/userWidgets`]) {
        resolve(store.getters[`commons/userWidgets`])
  
      } else {
        try {
          var path = '/v1/getUserWidgets/' + userId
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/userWidgets`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }
  // `params` is the dashboard filter bar (see mbp/dashboard/dashboardFilterBar.js): only the
  // dimensions and date that are set, so an untouched dashboard sends none.
  getUserWidgetData(userId, params) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/getUserWidgetData/' + userId
        
        var response = await axios.get(path, { params: params || {} })
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  // What each of this user's widgets opens when clicked: the report, and the filters it ran
  // with, so the report arrives at the same figure (see mbp/dashboard/dashboardDrill.js). Takes
  // the same bar parameters as getUserWidgetData, because the filters depend on them.
  getUserWidgetDrills(userId, params) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/getUserWidgetDrills/' + userId
        var response = await axios.get(path, { params: params || {} })
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  // The caller's saved dashboard view. No userId: the backend resolves the signed-in user.
  // The self-select screen and the dashboard layout (item 4 W3, contract §4). None of these
  // takes a user id: the backend resolves the signed-in user, so one user can never rearrange
  // or empty another's dashboard.
  getMyDashboardWidgets() {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/myDashboardWidgets'

        var response = await axios.get(path)

        resolve(response.data)
      } catch (err) {

        reject(err)
      }
    })
  }

  setMyDashboardWidget(widgetId, active) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/myDashboardWidgets/' + widgetId

        var response = await axios.put(path, { active: active })

        resolve(response.data)
      } catch (err) {

        reject(err)
      }
    })
  }

  // The whole layout in one call: [{ id, displayOrder, colSpan }, ...].
  saveMyDashboardLayout(layout) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/myDashboardLayout'

        var response = await axios.put(path, { layout: layout })

        resolve(response.data)
      } catch (err) {

        reject(err)
      }
    })
  }

  // The widget builder (item 4 W5, contract §6 and §6.1). Everything the compose screen offers
  // comes from this one call - the reports that can be aggregated over, each with its own
  // columns, the aggregates, the date periods, the comparison periods, the value types and the
  // icons - so the screen can never offer something the validator would then refuse.
  getWidgetComposerOptions() {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/widgetComposerOptions'

        var response = await axios.get(path)

        resolve(response.data)
      } catch (err) {

        reject(err)
      }
    })
  }

  // Create a catalogue widget. The rejection carries a message written to be read by a person
  // and naming the part that was wrong (contract §6), so the caller shows it as it arrives.
  createDashboardWidget(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/dashboardWidgets'

        var response = await axios.post(path, obj)

        resolve(response.data)
      } catch (err) {

        reject(err)
      }
    })
  }

  // One catalogue widget's definition: exactly the fields the compose body takes, so what comes
  // back from here can be posted straight back to updateDashboardWidget and store the same
  // widget. That round trip is what makes an existing widget editable at all - GET
  // v1/dashboardWidgets lists the catalogue, but not the definition behind each entry.
  getDashboardWidgetDefinition(id) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/dashboardWidgets/' + id + '/definition'

        var response = await axios.get(path)

        resolve(response.data)
      } catch (err) {

        reject(err)
      }
    })
  }

  // Update one. There is deliberately no delete: a catalogue widget may already be on other
  // people's dashboards, and W3 made removal a per-user deactivation (contract §6).
  updateDashboardWidget(id, obj) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/dashboardWidgets/' + id

        var response = await axios.put(path, obj)

        resolve(response.data)
      } catch (err) {

        reject(err)
      }
    })
  }

  getDashboardSavedView() {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await axios.get('/v1/dashboardSavedView')
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }
  saveDashboardSavedView(body) {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await axios.put('/v1/dashboardSavedView', body)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }
  clearDashboardSavedView() {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await axios.delete('/v1/dashboardSavedView')
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  copyUserWidgetData(fromUserId, toUserId) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/copyUserWidgets/' + fromUserId + '/' +toUserId
        
        var response = await axios.post(path)
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getActiveRolesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeRoles'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/activeRoles`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getActiveRoles() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/activeRoles`]) {
        resolve(store.getters[`commons/activeRoles`])
  
      } else {
        try {
          var path = '/v1/activeRoles'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/activeRoles`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }
  getRolesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/roles'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/roles`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getRoles() {
    return new Promise(async (resolve, reject) => {
      if (store.getters[`commons/roles`]) {
        resolve(store.getters[`commons/roles`])
  
      } else {
        try {
          var path = '/v1/roles'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/roles`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }

  getAllActiveUsersByHard() {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/activeUsers'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/activeusers`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllActiveUsers() {
    return new Promise(async (resolve, reject) => {
      if (store.getters[`commons/activeusers`]) {
        resolve(store.getters[`commons/activeusers`])
  
      } else {
        try {
          var path = '/v1/activeUsers'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/activeusers`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }
  getAllUsersByHard() {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/users'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/users`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllUsers() {
    return new Promise(async (resolve, reject) => {
      if (store.getters[`commons/users`]) {
        resolve(store.getters[`commons/users`])
  
      } else {
        try {
          var path = '/v1/users'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/users`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }
 
  //MBP

  updateUserById(user, id) {
    let a = {...user}
    if (user.defRegion && user.defRegion.id) {
      a.defRegion = user.defRegion.id
    }
    if (user.role && user.role.id) {
      a.role = user.role.id
    }

    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/updateUser/' + id
        
        var response = await axios.put(path, a)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  updateUser(user) {
    let a = {...user}
    if (user.defRegion && user.defRegion.id) {
      a.defRegion = user.defRegion.id
    }
    if (user.role && user.role.id) {
      a.role = user.role.id
    }

    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/updateUser/'
        
        var response = await axios.put(path, a)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  updateAUser(user) {
    if (user.id) {
      return new Promise(async function(resolve, reject) {
        try {
          var path = '/v1/updateUser/' + user.id
          
          var response = await axios.put(path, user)
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      })
    } else {
      
    }
  }
  updateNewUser(user) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/updateNewUser/'
        
        var response = await axios.put(path, user)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  // Admin only: makes the Firebase login and the CRM user in one step, from the Users form's details.
  createUserWithLogin(user) {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await axios.post('/v1/createUserWithLogin', user)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  updatePassword(payload) {
    return new Promise(async (resolve, reject) => {
      try {
        
        var response = await axios.post('https://identitytoolkit.googleapis.com/v1/accounts:update?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw', payload)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  changeEmail(payload) {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await axios.post('https://identitytoolkit.googleapis.com/v1/accounts:update?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw', payload)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  refreshToken(refreshToken) {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await axios.post(
          'https://securetoken.googleapis.com/v1/token?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw', 
          {
            grant_type: refresh_token,
            refresh_token: refreshToken
          }
        )
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  async sendResetPasswordEmail(payload) {
    // try {
      
      var response = await axios.post('https://identitytoolkit.googleapis.com/v1/accounts:sendOobCode?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw', payload)
      
      return response.data
    // } catch (err) {
    //   // 
    //   return err.response.data.error.message
    // }
  }

  async login(user) {
    // try {
      
      var response = await axios.post('https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw', user)
      
      return response.data
    // } catch (err) {
    //   // 
    //   return err.response.data.error.message
    // }
  }

  getUserLoginHistory(id) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/loginHistoryByUser/' + id
        var response = await axios.get(path)
        
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getUserById(id) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/user/' + id
        var response = await axios.get(path)
        
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getUser(token) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/user/profile'
        var response = await axios.get(path)
        
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getNotifications() {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/user/getNotifications'
        var response = await axios.get(path)
        
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updateNotifications(data) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/user/updateNotifications'
        var response = await axios.put(path, data)
        
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

}
